import Vue from 'vue'
import axios from 'axios'
import i18n from './i18n.js'
import {
  ERROR_CODE_NETWORK
} from '@/constants/settings'

Vue.axios = Vue.prototype.$http = axios.create({
})

Vue.axios.interceptors.request.use(function (config) {
  config.headers['x-locale'] = i18n.locale
  return config
})

Vue.axios.interceptors.response.use(response => response,
  error => {
    const response = error?.response
    if (!response) {
      error.status = ERROR_CODE_NETWORK
    }
    throw error
  })
